export class VisionApiURIs {
  // Authorization
  public static authorizationBase = '/authorization';
  public static getAuthToken = `${VisionApiURIs.authorizationBase}/token`;

  //EdpSync
  public static syncPharmacyNpis = '/edpSync/pharmacyNpis';

  //Functionality
  public static functionalityPermissions = '/functionality/permissions';

  //Roles
  public static lookupRolesForUsers = '/roles/lookupForUsers';
  public static functionalityPermissionsByRole = (roleId: string) => `/roles/${roleId}/functionality`;

  // Drugs
  public static getDrugQuoteType = (facilityId: string = '') => `/drugQuotes/setup/inactiveTypes?facilityId=${facilityId}`;
  public static addDrugQuoteType = () => '/drugQuotes/setup/inactiveTypes';

  // Facilities
  public static getAdditionalOrderMessageFields = (facilityId: string = '') => `/facilities/options/additionalOrderMessageFields?facilityId=${facilityId}`;
  public static addAdditionalOrderMessageFields = () => '/facilities/options/additionalOrderMessageFields';
  public static deleteAdditionalOrderMessageFields = (fieldId: string) => `/facilities/options/additionalOrderMessageFields?fieldId=${fieldId}`;
}
